<template>
  <div id="app">
    <input type="checkbox" class="header__hamburger__toggle" id="header__hamburger__toggle"
           :checked="menuactive"/>

    <template v-if="$route.meta.public || !$store.getters['auth/isAuth']">

      <Outdated/>

      <Header status="guest"/>

      <div class="navigation__overlay"></div>
      <Navigation status="guest"/>

      <section class="content__wrapper" id="content__wrapper">

        <div class="message" v-if="beta" v-html="$t('general.beta')"></div>

        <router-view class="app-content"/>

        <AppFooter/>

      </section>

    </template>

    <template v-else>

      <Header/>

      <div class="navigation__overlay"></div>
      <Navigation/>

      <section class="content__wrapper" id="content__wrapper">

        <div class="message" v-if="beta" v-html="$t('general.beta')"></div>

        <div class="loading--wrapper" v-if="$store.getters['loader/intLoading']">
          <div class="loading">
            <div class="loading__animation"></div>
            <div class="loading__text">{{ $t('general.loading') }}</div>
          </div>
        </div>

        <router-view class="app-content"/>

        <AppFooter/>

      </section>

    </template>

  </div>
</template>

<style lang="scss">
  @import 'assets/sass/app.scss';
</style>

<script>
import { mapState } from 'vuex'
import Navigation from '@/components/Navigation.vue'
import Header from '@/components/Header.vue'
import Outdated from '@/components/Parts/Outdated'
import AppFooter from '@/components/Footer'
import { BETA } from '@/constants'

export default {
  name: 'app',
  components: {
    Navigation,
    Header,
    Outdated,
    AppFooter
  },
  data () {
    return {
      beta: BETA
    }
  },
  methods: {},
  metaInfo: {
    title: 'Fusebox',
    htmlAttrs: {
      lang: 'en',
      amp: true
    }
  },
  computed: {
    ...mapState('menu', [
      'menuactive'
    ])
  }
}
</script>
